import { IBank, IPayoutAccount } from '@pharvio/core/shared';

export const PAYOUT_ACCOUNTS_FIXTURES: IPayoutAccount[] = [
  {
    id: 'pa-001',
    branchId: null,
    label: 'Main GTBank account',
    bankCode: '058',
    bankName: 'GTBank',
    // accountNumberMasked: '••••4821',
    accountName: 'MEDPLUS PHARMACY LTD',
    accountNumber: '0123456789',
    status: 'ACTIVE',
    suspendedReason: null,
    firstUsedAt: null,
    createdAt: new Date().toISOString()
  }
];

export const BANKS_FIXTURES: IBank[] = [
  { code: '044', name: 'Access Bank' },
  { code: '023', name: 'Citibank' },
  { code: '063', name: 'Diamond Bank' },
  { code: '050', name: 'EcoBank' },
  { code: '070', name: 'Fidelity Bank' },
  { code: '011', name: 'First Bank of Nigeria' },
  { code: '214', name: 'First City Monument Bank' },
  { code: '058', name: 'GTBank' },
  { code: '030', name: 'Heritage Bank' },
  { code: '301', name: 'Jaiz Bank' },
  { code: '082', name: 'Keystone Bank' },
  { code: '526', name: 'Parallex Bank' },
  { code: '076', name: 'Polaris Bank' },
  { code: '101', name: 'ProvidusBank' },
  { code: '221', name: 'Stanbic IBTC Bank' },
  { code: '068', name: 'Standard Chartered' },
  { code: '232', name: 'Sterling Bank' },
  { code: '100', name: 'SunTrust Bank' },
  { code: '032', name: 'Union Bank' },
  { code: '033', name: 'United Bank for Africa' },
  { code: '215', name: 'Unity Bank' },
  { code: '035', name: 'Wema Bank' },
  { code: '057', name: 'Zenith Bank' }
];
